import UsuarioService from '../../services/UsuarioService'

const state = {
  usuarios: [],
  usuario: null,
  totalItems: 0,
  currentPage: 1,
  itemsPerPage: 20
}

const getters = {
  usuarios: state => state.usuarios,
  usuario: state => state.usuario,
  totalItems: state => state.totalItems,
  currentPage: state => state.currentPage,
  itemsPerPage: state => state.itemsPerPage
}

const actions = {
  async fetchUsuarios({ commit, state }, { page = 1, filters = {} }) {
    try {
      const response = await UsuarioService.getUsuarios(page, state.itemsPerPage, filters)
      commit('setUsuarios', response.data.data)
      commit('setTotalItems', response.data.pagination?.total || 0)
      commit('setCurrentPage', page)
      return response
    } catch (error) {
      console.error('Error fetching usuarios:', error)
      throw error
    }
  },

  async fetchUsuario({ commit }, id) {
    try {
      const response = await UsuarioService.getUsuario(id)
      commit('setUsuario', response.data.data)
      return response
    } catch (error) {
      throw error
    }
  },

  async createUsuario({ commit }, usuario) {
    try {
      const response = await UsuarioService.createUsuario(usuario)
      return response
    } catch (error) {
      throw error
    }
  },

  async updateUsuario({ commit }, { id, usuario }) {
    try {
      const response = await UsuarioService.updateUsuario(id, usuario)
      return response
    } catch (error) {
      throw error
    }
  },

  async deleteUsuario({ commit }, id) {
    try {
      const response = await UsuarioService.deleteUsuario(id)
      return response
    } catch (error) {
      throw error
    }
  },

  async exportarListado({ commit }, { formato, filtros }) {
    try {
      const response = await UsuarioService.exportarListado(formato, filtros)
      return response
    } catch (error) {
      throw error
    }
  },

  async fetchGestionesFederacion({ commit }, idUsuario) {
    try {
      const response = await UsuarioService.getGestionesFederacion(idUsuario)
      return response
    } catch (error) {
      throw error
    }
  },

  async fetchGestionesOrganizacion({ commit }, idUsuario) {
    try {
      const response = await UsuarioService.getGestionesOrganizacion(idUsuario)
      return response
    } catch (error) {
      throw error
    }
  }
}

const mutations = {
  setUsuarios(state, usuarios) {
    state.usuarios = usuarios
  },
  setUsuario(state, usuario) {
    state.usuario = usuario
  },
  setTotalItems(state, total) {
    state.totalItems = total
  },
  setCurrentPage(state, page) {
    state.currentPage = page
  },
  setItemsPerPage(state, itemsPerPage) {
    state.itemsPerPage = itemsPerPage
  }
}

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
}